import { Link, useNavigate } from 'react-router-dom';
import { GalaxyBackground } from '../components/GalaxyBackground';
import { LandingNavDropdown } from '../components/LandingNavDropdown';
import { TypewriterHeadline } from '../components/TypewriterHeadline';
import './LandingPage.css';

export function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing">
      <header className="landing__nav">
        <Link to="/" className="landing__brand">
          <span className="landing__logo-box" aria-hidden>
            <img src="/dap-logo.png" alt="DAP-AI logo" className="landing__logo" />
          </span>
          <span className="landing__brand-name">DAP-AI</span>
        </Link>

        <nav className="landing__links" aria-label="Primary">
          <LandingNavDropdown />
          <Link to="/portal/sqm-data-hub">SQM Data Hub</Link>
          <Link to="/portal/contributions">Contributions</Link>
        </nav>

        <button
          type="button"
          className="landing__cta landing__cta--sm"
          onClick={() => navigate('/portal')}
        >
          Enter Portal
        </button>
      </header>

      <main className="landing__hero">
        <GalaxyBackground />

        <div className="landing__hero-content">
          <TypewriterHeadline />
          <p className="landing__subhead">
            DAP-AI connects design, manufacturing, and field data to predict,
            prevent, and resolve quality issues — faster.
          </p>
          <button
            type="button"
            className="landing__cta"
            onClick={() => navigate('/portal')}
          >
            Enter DAP-AI Portal
          </button>
        </div>

        <p className="landing__footnote">Powered by the Data Automation Platform</p>
      </main>
    </div>
  );
}
